import type { ReactNode } from 'react';
import type { Video } from '@blackblack/shared';
import { formatCount } from '@blackblack/shared';
import { navigate } from '../lib/router';
import { Icon } from './ui/Icon';
import { LoadMore, Skeleton } from './ui/primitives';
import styles from './grid.module.css';

/** 3-column 9:16 thumbnail grid. Opening a tile continues as a swipeable feed of the grid. */
export function VideoGrid({
  items,
  loading,
  hasMore,
  loadingMore,
  onLoadMore,
  empty,
  badge,
}: {
  items: Video[];
  loading: boolean;
  hasMore: boolean;
  loadingMore: boolean;
  onLoadMore: () => void;
  empty?: ReactNode;
  badge?: (v: Video) => ReactNode;
}) {
  if (loading) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: 9 }, (_, i) => (
          <Skeleton key={i} h="auto" r={4} className={styles.skel} />
        ))}
      </div>
    );
  }
  if (!items.length) return <>{empty}</>;
  return (
    <>
      <div className={styles.grid}>
        {items.map((v, i) => (
          <button key={v.id} className={styles.tile} onClick={() => navigate(`/v/${v.id}`, { state: { videos: items, index: i } })} aria-label={v.caption || `Video van ${v.author.displayName}`}>
            {v.thumbnailUrl ? <img src={v.thumbnailUrl} alt="" loading="lazy" decoding="async" /> : <span className={styles.noThumb} />}
            {badge?.(v)}
            <span className={styles.views}>
              <Icon name="play" size={12} /> {formatCount(v.stats.views)}
            </span>
          </button>
        ))}
      </div>
      <LoadMore onVisible={onLoadMore} loading={loadingMore} hasMore={hasMore} />
    </>
  );
}
